import theme from 'theme'
import { last } from 'utils/list'

export function getColorForStage(stage) {
  switch (stage.toLowerCase()) {
    case 'pending':
    case 'distributed':
    case 'impacted':
      return theme.colors.blue[0]
    case 'successful':
      return theme.colors.green[0]
    case 'halted':
      return theme.colors.yellow[0]
    case 'applicationnotfound':
    case 'trafficnotfound':
      return theme.colors.steel[1]
    default:
      return theme.colors.steel[1]
  }
}

export function formatTypePropertyWithMetadata(query, metadata = []) {
  const match = metadata.find(m => m.type === query.type)
  return match ? match.name : query.type
}

export function formatFieldWithMetadata(key, value, query, metadata = []) {
  const match = metadata.find(m => m.type === query.type)

  if (!match) {
    return {
      key,
      value
    }
  }

  const fieldMetadata = match.fields.find(f => f.key === key)

  if (!fieldMetadata) {
    return { key, value }
  }

  let formattedValue
  switch (fieldMetadata.type) {
    case 'Boolean':
      formattedValue = value == null || value === false ? 'No' : 'Yes'
      break
    case 'Integer':
    case 'Float':
    case 'String':
    case 'Enum':
    default:
      formattedValue = value
  }

  return {
    key: fieldMetadata.name,
    value: formattedValue === '*' ? 'any' : formattedValue,
    info: fieldMetadata.info
  }
}

export function createUrlPathFromAttack(attack) {
  return window.encodeURIComponent(JSON.stringify(attack))
}

export function isTerminalState(attackState) {
  return [
    'Halted',
    'ApplicationNotFound',
    'TrafficNotFound',
    'Successful'
  ].includes(attackState)
}

export function getAutocompleteValuesForFieldName(name, clientList, limit) {
  const clients = clientList
  let i = 0
  let values = new Set()

  while (i < clients.length && values.size <= limit) {
    const client = clients[i]
    const value = client.coordinates[name]
    if (value) {
      values.add(value)
    }

    ++i
  }
  return Array.from(values)
}

export function isExperimentHalting(states) {
  const { stage } = last(states)
  return ['Halted', 'HaltRequested'].includes(stage)
}
